"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCultureOrder = exports.SET_CULTURE_ORDER = exports.setCulture = exports.SET_CULTURE = exports.initCulture = exports.INIT_CULTURE = exports.registerLanguage = exports.REGISTER_LANGUAGE = exports.setLanguageCultureMap = exports.SET_LANGUAGE_CULTURE_MAP = exports.setLanguage = exports.SET_LANGUAGE = exports.setLanguageOrder = exports.SET_LANGUAGE_ORDER = exports.initLanguage = exports.INIT_LANGUAGE = void 0;

var _getActionName = require("../utils/get-action-name");

var _constants = require("../../constants");

var _createAction = require("../base/create-action");

var INIT_LANGUAGE = (0, _getActionName.getActionName)('INIT_LANGUAGE', _constants.MODULE_NAME);
exports.INIT_LANGUAGE = INIT_LANGUAGE;

var initLanguage = function initLanguage() {
  return (0, _createAction.createAction)(INIT_LANGUAGE, {});
};

exports.initLanguage = initLanguage;
var SET_LANGUAGE_ORDER = (0, _getActionName.getActionName)('SET_LANGUAGE_ORDER', _constants.MODULE_NAME);
exports.SET_LANGUAGE_ORDER = SET_LANGUAGE_ORDER;

var setLanguageOrder = function setLanguageOrder(languageOrder) {
  return (0, _createAction.createAction)(SET_LANGUAGE_ORDER, {
    languageOrder: languageOrder
  });
};

exports.setLanguageOrder = setLanguageOrder;
var SET_LANGUAGE = (0, _getActionName.getActionName)('SET_LANGUAGE', _constants.MODULE_NAME);
exports.SET_LANGUAGE = SET_LANGUAGE;

var setLanguage = function setLanguage(language) {
  return (0, _createAction.createAction)(SET_LANGUAGE, {
    language: language
  });
};

exports.setLanguage = setLanguage;
var SET_LANGUAGE_CULTURE_MAP = (0, _getActionName.getActionName)('SET_LANGUAGE_CULTURE_MAP', _constants.MODULE_NAME);
exports.SET_LANGUAGE_CULTURE_MAP = SET_LANGUAGE_CULTURE_MAP;

var setLanguageCultureMap = function setLanguageCultureMap(languageCultureMap) {
  return (0, _createAction.createAction)(SET_LANGUAGE_CULTURE_MAP, {
    languageCultureMap: languageCultureMap
  });
};

exports.setLanguageCultureMap = setLanguageCultureMap;
var REGISTER_LANGUAGE = (0, _getActionName.getActionName)('REGISTER_LANGUAGE', _constants.MODULE_NAME);
exports.REGISTER_LANGUAGE = REGISTER_LANGUAGE;

var registerLanguage = function registerLanguage(language, messages) {
  return (0, _createAction.createAction)(REGISTER_LANGUAGE, {
    language: language,
    messages: messages
  });
};

exports.registerLanguage = registerLanguage;
var INIT_CULTURE = (0, _getActionName.getActionName)('INIT_CULTURE', _constants.MODULE_NAME);
exports.INIT_CULTURE = INIT_CULTURE;

var initCulture = function initCulture() {
  return (0, _createAction.createAction)(INIT_CULTURE, {});
};

exports.initCulture = initCulture;
var SET_CULTURE = (0, _getActionName.getActionName)('SET_CULTURE', _constants.MODULE_NAME);
exports.SET_CULTURE = SET_CULTURE;

var setCulture = function setCulture(culture) {
  return (0, _createAction.createAction)(SET_CULTURE, {
    culture: culture
  });
};

exports.setCulture = setCulture;
var SET_CULTURE_ORDER = (0, _getActionName.getActionName)('SET_CULTURE_ORDER', _constants.MODULE_NAME);
exports.SET_CULTURE_ORDER = SET_CULTURE_ORDER;

var setCultureOrder = function setCultureOrder(cultureOrder) {
  return (0, _createAction.createAction)(SET_CULTURE_ORDER, {
    cultureOrder: cultureOrder
  });
};

exports.setCultureOrder = setCultureOrder;
//# sourceMappingURL=actions.js.map